export const meetings = [
  {
    path: '/meetings',
    component: () => import(/* webpackChunkName: "meetings" */ '@/views/meetings/Meetings'),
  },
]
